module.exports = __webpack_public_path__ + "img/Lightbrown.3cd242b9.png";